import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid
} from 'recharts';
import swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { CustomTooltip } from './CustomTooltip.jsx';
import { TicketsInfoModal } from './TicketsInfoModal.jsx';
import { prepareDataForChart } from '../helpers/prepareDataForChart.js';

import "./StatisticBarChart.sass";

const MySwal = withReactContent(swal);

export const StatisticBarChart = ({ eventData, dataPerPeriod, searchPeriod }) => {
  const [maxTicketsAmount, setMaxTicketsAmount] = useState(0);
  const [chartData, setChartData] = useState([]);

  const handleChartBarClick = (e) => {
    MySwal.fire({
      title: `${e.date}`,
      html: <TicketsInfoModal
        amount={e.amount}
        ticketsInfo={e.ticketsInfo}
        currency={eventData.currency}
      />,
      customClass: 'swal2-modal',
      width: '1000px',
    })
  };

  useEffect(() => {
    const dataForChart = prepareDataForChart({
      dataPerPeriod,
      searchPeriodValue: searchPeriod.value,
      eventData,
    });

    setChartData(dataForChart);

    const maxAmount = Math.max(...dataForChart.map(item => item.amount));
    setMaxTicketsAmount(maxAmount);
  }, [dataPerPeriod])

  return (
    <ResponsiveContainer className={"statistic-bar-chart"} width="100%" height="100%">
      <BarChart
        margin={{
          top: 20,
          right: 20,
          left: 20,
          bottom: 40,
        }}
        data={chartData}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="label"
          angle={-45}
          tickMargin={10}
          label={{ value: 'Date&Time', position: 'bottom', offset: 15 }}
        />
        <YAxis
          tickCount={maxTicketsAmount < 10 ? maxTicketsAmount + 1 : 10}
          label={{ value: 'Tickets amount', angle: -90, position: 'insideLeft' }}
        />
        <Tooltip
          wrapperStyle={{ background: 'transparent', maxHeight: '280px' }}
          content={<CustomTooltip currency={eventData.currency} />}
          cursor={{ fill: "var(--secondary-light-color)", }}
        />
        <Bar dataKey="amount" fill="var(--secondary-color)" onClick={handleChartBarClick} />
      </BarChart>
    </ResponsiveContainer>
  )
}
